import _Vue from "vue"


//Custom press plugin
//@click on custom components works by going through spatial-nav library
//However this manifests as a double event (click and keyup) for the same press for some TVs.
//on non component elements we need @click and v-on:keyup.13.
//This plugin pushes that all together into a custom flow
interface PressElement extends HTMLElement {
  __pressHandlers__?: {
    click: (event: MouseEvent) => void;
    keyup: (event: KeyboardEvent) => void;
  };
}

class PressPlugin {
  public install(Vue: typeof _Vue) {

    Vue.directive('press', {

      bind(el, binding) {
        const element = el as PressElement;

        //We need a tab index for the DOM focus so keyboard events go to it
        //Separate to focus engine
        if (!element.hasAttribute('tabindex')) {
          element.setAttribute('tabindex', '0');
        }

        //Helper to call the binding function with response
        //The actual function passed to plugin
        const invoke = (source: string) => {
          if (typeof binding.value !== 'function') {
            console.warn('v-press expects a function, received:', typeof binding.value);
            return;
          }
          binding.value(source);
        };

        //Click handler
        const click = (event: MouseEvent) => {
          //On vestel TVs a click event is also sent.
          //The Detail is 0 in this instance so we can ignore
          //detail is the click count so normal clicks will have detail > 0
          if (event.detail === 0) return;
          invoke('click');
        };

        const keyup = (event: KeyboardEvent) => {
          //Keyup handler for Enter key - Central location where we can define keycodes per TV if necessary
          if (event.key === 'Enter' || event.keyCode === 13) {
            invoke('keyup');
          } 
          return;
        };

        element.addEventListener('click', click);
        element.addEventListener('keyup', keyup);

        // Stashed on the element so unbind can remove exactly these listeners.
        element.__pressHandlers__ = { click, keyup };
      },

      unbind(el) {
        const element = el as PressElement;
        const handlers = element.__pressHandlers__;
        if (!handlers) return;

        element.removeEventListener('click', handlers.click);
        element.removeEventListener('keyup', handlers.keyup);
        delete element.__pressHandlers__;
      },
    });
  }
}

export default new PressPlugin();
